import React, { useState, useEffect, useRef } from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from '../redux/actions/appAction'
import { getAllScopes, getAllUnits } from '../redux/actions/projectAction';
import { connect, useSelector } from 'react-redux'
import { getAllMaterials } from '../redux/actions/vendorAction';
import { ROLENAME, DONT_SHOW_REMAP_TABLE} from '../utils/index';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import DeleteIcon from '@material-ui/icons/Delete'
import moment from 'moment/moment';


const filter = createFilterOptions();


const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  root: {
    width: '100%',
  },
  textField: {
    width: "100px"
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);



const optionLabel = (option) => (typeof option === "string" ? option : (option?.name ?? ""));

const optionSelected = (option, value) => {
  if (!option || !value) return false;
  if (option._id && value._id) return option._id.toString() === value._id.toString();
  return optionLabel(option) === optionLabel(value);
};

const ROW_RENDER_CHUNK = 25;
const MASTER_CACHE_TTL_MS = 5 * 60 * 1000;
const masterCache = new Map();
const loadMaster = (key, loader) => {
  const cached = masterCache.get(key);
  if (cached && cached.expiresAt > Date.now()) return cached.promise;
  const promise = loader();
  promise.catch(() => masterCache.delete(key));
  masterCache.set(key, { promise, expiresAt: Date.now() + MASTER_CACHE_TTL_MS });
  return promise;
};
export const clearBomMasterCache = () => masterCache.clear();

const BomTable = (props) => {
  const classes = useStyles();

  const setGlobalLoading = (value) => {
    if (!props.SUPPRESSGLOBALLOADER) props.setLoading(value)
  }


  const [mastersLoaded, setMastersLoaded] = useState(false)
  const [bomLoaded, setBomLoaded] = useState(false)
  const readyNotified = useRef(false)

  useEffect(() => {
    Promise.all([
      getAllScopes(),
      getAllUnits(),
      getAllRooms(),
      getAllSubCategory(),
      getAllMaterials()
    ]).catch(() => { }).then(() => setMastersLoaded(true))
    populateTableRows()
  }, [props.MOUNTED, props.IomsData])

  const { userDetails } = useSelector(state => state.user)
  const { allMaterials } = useSelector(state => state.vendor)
  const { scopes, units } = useSelector(state => state.project)

  const [tableRows, setTableRows] = useState([{ value: null }])
  const [rooms, setRooms] = useState([])
  const [subCategory, setSubCategory] = useState([])
  const [subCategoryList, setSubCategoryList] = useState([])
  const [selectedRoom, setSelectedRoom] = useState([])
  const [selectedScope, setSelectedScope] = useState([])
  const [selectedSubCategory, setSelectedSubCategory] = useState([])
  const [selectedMaterial, setSelectedMaterial] = useState([])
  const [selectedUom, setSelectedUom] = useState([])
  const [quantity, setQuantity] = useState([])
  const [rowsToAdd, setRowsToAdd] = useState(0)
  const [userRoleAccess, setUserRoleAccess] = useState(false)
  const [fieldsDisabled, setFieldsDisabled] = useState(false)
  
  const [commonBomItemsAdded, setCommonBomItemsAdded] = useState(false)
  const [showCommonBomItems, setShowCommonBomItems] = useState(false)
  
  const [commonBomItems, setCommonBomItems] = useState([])
  const [uploadDetails, setUploadDetails] = useState([])
  const [isInitiationBom, setIsInitiationBom] = useState(false);
  // A generated Initiation BOM is always an Initiation BOM, so its checkbox stays checked.
  const initiationBomChecked = !!props.LOCKINITIATIONBOM || isInitiationBom;


  const getAllScopes = async () => {
    if (scopes?.length) return
    try {
      await props.getAllScopes()
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo('Error fetching scopes', "error")
    }
  }

  const getAllUnits = async () => {
    if (units?.length) return
    try {
      await props.getAllUnits()
      // console.log('units', units)
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo('Error fetching units', "error")
    }
  }


  const getAllRooms = async () => {
    try {
      const result = await loadMaster('rooms', () => HttpService.getAllRooms())
      setRooms(result.data)
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo('Error fetching rooms', "error")

    }
  }

  const getAllSubCategory = async () => {
    try {
      const response = await loadMaster('subCategories', () => HttpService.getAllSubCategory())
      setSubCategoryList(response.data)
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo(error?.response?.data?.messsage ?? "Error fetching sub categories", "error")
    }
  }

  const getAllMaterials = async () => {
    setGlobalLoading(true)
    try {
      if (!allMaterials?.length) await props.getAllMaterials()
      let my_common_bom_items = allMaterials.filter(material => material.isCommonBomItem)
      let data = []
      for(let i = 0; i < my_common_bom_items.length; i++)
      {
        let obj = {}
        obj.material = my_common_bom_items[i]
        obj.quantity = ''
        obj.scope = {}
        obj.space = {}
        obj.subCategory = my_common_bom_items[i].subCategoryId
        obj.unitType = {}
        data.push(obj)
      }

      setCommonBomItems([...data])
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.messsage ?? "Error fetching materials", "error")
    }
    setGlobalLoading(false)
  }

  

  useEffect(() => {
    if (props.TYPE === "CREATE")
      getBom()
    else if(props.TYPE === "VIEW-PENDING")
      showBomApprovalPending();
    else
      viewPreviousBom()

  }, [])

  const viewPreviousBom = async () => {
    setGlobalLoading(true)
    try {
      const response = await HttpService.getPreviousBomForProject(props.SELECTEDPROJECT._id)
      setData(response)
      setFieldsDisabled(true)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    setBomLoaded(true)
    setGlobalLoading(false)
  }

  const showBomApprovalPending = async () => {
    setGlobalLoading(true)
    try {
      const bomApprovalPending = await HttpService.getBomPendingForApprovalProjectId(props.SELECTEDPROJECT._id);
      setData(bomApprovalPending);
      setFieldsDisabled(true);
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    setBomLoaded(true)
    setGlobalLoading(false)
  }  

  const getBom = async () => {
    setGlobalLoading(true)
    try {
      const clickedBomType = props.VIEWBOMTYPE || "";
      const serverSideBomType = props.BUTTONCLICKEDAPPROVED ? clickedBomType : ""
      const result = await HttpService.getSavedProjectMaterialForBom(props.SELECTEDPROJECT._id, serverSideBomType, props.INCLUDESAVED)
      const matchedData = result.data ? result.data.filter(item => item.bomType === clickedBomType && (clickedBomType !== "Hardware BOM" || !!item.isMismatchedHardware === !!props.VIEWMISMATCHEDHARDWARE)) : [];
      const simpleObjectFormat = matchedData.reduce((acc, item) => {
          acc = {
              status: item.status,
              deleted: item.deleted,
              _id: item._id,
              approvals: item.approvals,
              bomType: item.bomType,
              isMismatchedHardware: item.isMismatchedHardware,
              createdAt: item.createdAt,
              materials: item.materials, 
              projectId: item.projectId,
              submittedAt: item.submittedAt,
              submittedBy: item.submittedBy,
              updatedAt: item.updatedAt,
              __v: item.__v,
          };
          return acc;
      }, {});
      setUploadDetails(simpleObjectFormat);

      if (props.BUTTONCLICKEDAPPROVED ? !simpleObjectFormat : !result?.data[0]) {
        setTableRows([{ value: null }])
        setSelectedRoom([])
        setSelectedScope([])
        setSelectedSubCategory([])
        setSelectedMaterial([])
        setSelectedUom([])
        setQuantity([])
      } else
      await props.BUTTONCLICKEDAPPROVED ? setData(simpleObjectFormat) : setData(result)    
    } catch (error) {
      console.error(error)
      props.setSnackInfo('Error fetching previous data', 'error')
    }
    setBomLoaded(true)
    setGlobalLoading(false)

  }


  const viewBomTypeInitialised = useRef(false)
  useEffect(() => {
    if (!viewBomTypeInitialised.current) {
      viewBomTypeInitialised.current = true
      return
    }
    getBom();
  }, [props.VIEWBOMTYPE, props.VIEWMISMATCHEDHARDWARE]);

  const [inActiveMaterials, setInActiveMaterials] = useState([])
  const setData = (result) => {
      setGlobalLoading(true)
      let rooms = []
      let scope = []
      let SelectedSubCategory = []
      let materials = []
      let uom = []
      let quant = []
      let inActiveMaterials = []
      if(props.BUTTONCLICKEDAPPROVED) {
        (result?.materials || []).map((material, i) => {
          if (material.materialId?.isActive) {
            rooms[i] = material.spaceNameId
            scope[i] = material.scopeId
            SelectedSubCategory[i] = material.subCategoryId
            materials[i] = material.materialId
            uom[i] = material.unitType
            quant[i] = material.quantity
          } else {
            inActiveMaterials.push(material)
          }
          return null
        })
      } else if(result.data[0]?.status === "Saved") {
        result.data[0]?.materials.map((material, i) => {
          if (material.materialId?.isActive) {
            rooms[i] = material.spaceNameId
            scope[i] = material.scopeId
            SelectedSubCategory[i] = material.subCategoryId
            materials[i] = material.materialId
            uom[i] = material.unitType
            quant[i] = material.quantity
          } else {
            inActiveMaterials.push(material)
          }
          return null
        })
      } else {
        (result?.data?.materials || []).map((material, i) => {
          if (material.materialId?.isActive) {
            rooms[i] = material.spaceNameId
            scope[i] = material.scopeId
            SelectedSubCategory[i] = material.subCategoryId
            materials[i] = material.materialId
            uom[i] = material.unitType
            quant[i] = material.quantity
          } else {
            inActiveMaterials.push(material)
          }
          return null
        })
      }
      addRows(null, rooms.length + 1)
      setInActiveMaterials(inActiveMaterials)
      setUserRoleAccess(userDetails.roles.find(role => role.name === "Operation Head" || role.name === "BOM Manager"))
      setSelectedRoom(rooms)
      setSelectedScope(scope)
      setSelectedSubCategory(SelectedSubCategory)
      setSelectedMaterial(materials)
      setSelectedUom(uom)
      setQuantity(quant)
  }

  const addRows = (e, value) => {
    let length = value ?? rowsToAdd
    const rows = []
    for (let i = 0; i < length; i++) {
      rows.push({ value: null })
    }
    setTableRows(rows)
    setRowsToAdd(0)
  }



  const handleScopeSelect = (e, value, i) => {
    if (value?._id) {
      getSelectedSubCategory(value?._id)
    }
    let scope = [...selectedScope]
    scope[i] = value
    setSelectedScope(scope)
  }

  const handleScopeSelectInCommonBomItems = (e, v, i) => {

    let data = [...commonBomItems]
    data[i].scope = v
    setCommonBomItems(data)
  }
  const handleRemoveCommonBomItemFromTable = (i) =>
  {
    let data = [...commonBomItems]
    data = data.filter((el, index) => index !== i)
    setCommonBomItems([...data])
  }

  const getSelectedSubCategory = async (scopeId) => {
    try {
      setGlobalLoading(true)
      const result = []
      for (let i = 0; i < subCategoryList.length; i++) {
        let scopedList = subCategoryList[i].scopeId.find(scope => scope._id.toString() === scopeId.toString())
        if (scopedList)
          result.push(subCategoryList[i])
      }
      setSubCategory(result)
      setGlobalLoading(false)
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo('Error fetching sub category', "error")
    }
  }

  const [selectedSubCategoryMaterial, setSelectedSubCategoryMaterial] = useState([])

  const handleSubCategorySelect = (e, value, i) => {
    if (value?._id) {
      getSelectedSubCategoryMaterial(value?._id)
    }
    let subCategory = [...selectedSubCategory]
    subCategory[i] = value
    setSelectedSubCategory(subCategory)
  }



  const getSelectedSubCategoryMaterial = async (subCatId) => {
    try {
      setGlobalLoading(true)
      console.log(subCatId.toString())
      const result = allMaterials.filter(material => material?.subCategoryId?._id?.toString() === subCatId.toString() && material?.status === "Active")
      setSelectedSubCategoryMaterial(result)
      setGlobalLoading(false)
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo(error?.response?.data?.messsage ?? 'Error fetching materials', "error")
    }
  }

  const handleRoomSelect = (e, v, i) => {
    let rooms = [...selectedRoom]
    rooms[i] = v
    setSelectedRoom(rooms)
  }

  const handleRoomSelectInCommonBomItems = (e, v, i) => {

    let data = [...commonBomItems]
    data[i].space = v
    setCommonBomItems(data)
  }

  const handleMaterialSelect = (e, v, i) => {
    let materials = [...selectedMaterial]
    materials[i] = v
    setSelectedMaterial(materials)
    if (v) {
      let uom = [...selectedUom]
      uom[i] = v?.unitId
      setSelectedUom(uom)
    } else {
      let uom = [...selectedUom]
      uom[i] = v
      setSelectedUom(uom)
    }
  }

  const handleUomSelectInCommonBomItems = (e, v, i) => {

    let data = [...commonBomItems]
    data[i].unitType = v
    setCommonBomItems(data)
  }

  const handleUomSelect = (e, v, i) => {
    let uom = [...selectedUom]
    uom[i] = v
    setSelectedUom(uom)
  }

  const handleQuantityInCommonBomItems = (e, i) => {

    let data = [...commonBomItems]
    data[i].quantity  = e.target.value
    setCommonBomItems(data)
  }

  const handleQuantity = (e, i) => {
    let quant = [...quantity]
    quant[i] = e.target.value
    setQuantity(quant)
  }

  const BomTypesStrings = [
    "Initiation BOM-Carpentry BOM",
    "Modular BOM",
    "Hardware BOM",
    "Snag BOM",
    "Non-Hettich BOM",
  ];

  const submit = async (status) => {
    setGlobalLoading(true)
    if (!props.BOMTYPE || !BomTypesStrings.includes(props.BOMTYPE)) {
      setGlobalLoading(false);
      props.setSnackInfo("Error: Invalid or missing BOM type", "error");
      return;
    }
    const projectMaterial = selectedRoom.map((item, i) => {
      let obj = {
        spaceNameId: item?._id,
        scopeId: selectedScope[i]._id,
        subCategoryId: selectedSubCategory[i]?._id,
        materialId: selectedMaterial[i],
        unitType: selectedUom[i],
        quantity: quantity[i]
      }
      return obj
    })
    const material = {}
    material.materials = projectMaterial
    material.status = status
    material.bomType = props.BOMTYPE
    material.isMismatchedHardware = props.BOMTYPE === "Hardware BOM" && !!props.ISMISMATCHEDHARDWARE
    material.submittedAt = new Date()
    material.selectedProject = props.SELECTEDPROJECT._id
    material.isInitiationBom = initiationBomChecked
    if (!props.SKIPCOMMONBOMITEMS && !commonBomItemsAdded)
    {
      setShowCommonBomItems(true)
      setGlobalLoading(false)
      return;
    }
    try {
      const response = await HttpService.createProjectMaterialFromBom(props.SELECTEDPROJECT._id, material)
      setGlobalLoading(false)
      props.setSnackInfo(response.data)
      await getBom()
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo(error?.response?.data ?? `Error while ${status === "Saved" ? 'saving' : 'submitting'} data`, "error")
    }
  }

  const resetBom = async () => {
    if (!window.confirm(`Reset will remove the saved (not submitted) ${props.BOMTYPE} of this project. Continue?`)) return
    setGlobalLoading(true)
    try {
      const response = await HttpService.resetSavedBom(props.SELECTEDPROJECT._id, {
        bomType: props.BOMTYPE,
        isMismatchedHardware: props.BOMTYPE === "Hardware BOM" && !!props.ISMISMATCHEDHARDWARE
      })
      props.setSnackInfo(response.data)
      props.ONRESET?.()
      await getBom()
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo(error?.response?.data ?? "Error while resetting BOM", "error")
    }
  }

  const addCommonBomItemsToBom = () =>
  {

    setCommonBomItemsAdded(true)
    setShowCommonBomItems(false)
    
    const rows = [...tableRows]
    for (let i = 0; i < commonBomItems.length; i++)
    {
      rows.push({ value: null })
    }
    setTableRows(rows)
    let my_rooms = [...selectedRoom]
    let my_scopes = [...selectedScope]
    let my_subCategorys = [...selectedSubCategory]
    let my_materials = [...selectedMaterial]
    let my_uoms = [...selectedUom]
    let my_quants = [...quantity]
    for (let i = 0; i < commonBomItems.length; i++)
    {

      my_rooms.push(commonBomItems[i].space)

      my_scopes.push(commonBomItems[i].scope)

      my_subCategorys.push(commonBomItems[i].subCategory)

      my_materials.push(commonBomItems[i].material)
 
      my_uoms.push(commonBomItems[i].unitType)

      my_quants.push(commonBomItems[i].quantity)

    }
    setSelectedRoom(my_rooms)
    setSelectedScope(my_scopes)
    setSelectedSubCategory(my_subCategorys)
    setSelectedMaterial(my_materials)
    setSelectedUom(my_uoms)
    setQuantity(my_quants)
  }
  const resetCommonBomItemsData = () =>
  {

    let my_common_bom_items = allMaterials.filter(material => material.isCommonBomItem)
      let data = []
      for(let i = 0; i < my_common_bom_items.length; i++)
      {
        let obj = {}
        obj.material = my_common_bom_items[i]
        obj.quantity = ''
        obj.scope = {}
        obj.space = {}
        obj.subCategory = my_common_bom_items[i].subCategoryId
        obj.unitType = {}
        data.push(obj)
      }
      setCommonBomItems([...data])
    setShowCommonBomItems(false)
  }

  const getSelectedRoom = (i) => {
    const item = selectedRoom[i]
    return item || null;
  }
  const getSelectedScope = (i) => {
    const item = selectedScope[i]
    return item || null
  }
  const getSelectedCategory = (i) => {
    const item = selectedSubCategory[i]
    return item || null
  }
  const getSelectedMaterial = (i) => {
    const item = selectedMaterial[i]
    return item || null
  }
  const getSelectedUom = (i) => {
    const item = selectedUom[i]
    return item || null
  }

  const editBomStatus = async (status) => {
    try {
      setGlobalLoading(true)
      const payload = {
        status,
        bomType: props.VIEWBOMTYPE,
      };
      if (props.VIEWBOMTYPE === "Hardware BOM") {
        payload.isMismatchedHardware = !!props.VIEWMISMATCHEDHARDWARE;
      }
      const result = await HttpService.editBomStatus(props.SELECTEDPROJECT._id, payload)
      if (result.status === 200) {
        setGlobalLoading(false)
        getBom()
        window.location.reload(true)
      }
      props.setSnackInfo('Bom status updated', "success")
    } catch (error) {
      console.error(error)
      setGlobalLoading(false)
      props.setSnackInfo('Error while updating the bom status', "error")
    }
  }

  const [remappedMaterial, setRemappedMaterial] = useState([])

  const remapMaterial = async (materialId, i) => {
    console.log(remappedMaterial, materialId, props.SELECTEDPROJECT._id)
    setGlobalLoading(true)
    try {
      await HttpService.remapMaterials({ remappedMaterial: remappedMaterial[i], materialId }, props.SELECTEDPROJECT._id)
      props.setSnackInfo('Successfully Remapped')
      let remappedMaterials = [...remappedMaterial]
      remappedMaterials.splice(i, 1)
      setRemappedMaterial(remappedMaterials)
      await getBom()
    } catch (error) {
      console.log(error)
      props.setSnackInfo('Error while reampping materials', "error")

    }
    setGlobalLoading(false)
  }

  const sendForApproval = async (materialId) => {
    setGlobalLoading(true)
    try {
      await HttpService.sendMaterialForApproval(materialId)
      props.setSnackInfo('Material Sent for Approval')
      await getBom()
    } catch (error) {
      console.log(error)
      props.setSnackInfo('Error while reampping materials', "error")
    }
    setGlobalLoading(false)
  }

  const handleRemapOfMaterial = async (v, i) => {
    let remappedMaterials = [...remappedMaterial]
    if (v?._id) {
      remappedMaterials[i] = v
    } else {
      remappedMaterials.splice(i, 1)
    }
    setRemappedMaterial(remappedMaterials)
  }

  const getRemappedMaterial = (i) => {
    const item = remappedMaterial[i]
    return item || null
  }

  const populateTableRows = () => {
 
    const iomsData = Array.isArray(props.IomsData) ? props.IomsData : [];

    const newRows = iomsData.map((data) => ({
      selectedRoom: data?.room || "",
      selectedMaterial: data?.materialName || "",
      qty: data?.unit || "",
    }));
    const DataSubCategory = newRows.map((row) => {
      if (row.selectedMaterial && row.selectedMaterial.subCategoryId) {
        return row.selectedMaterial.subCategoryId;
      }
      return null;
    });  
    
    const DataScope = newRows.map((row) => {
      if (row.selectedMaterial && row.selectedMaterial.subCategoryId && row.selectedMaterial.subCategoryId.scopeId.length > 0) {
        return row.selectedMaterial.subCategoryId.scopeId[0];
      }
      return ""; 
    });
    const DataUnit = newRows.map((row) => {
      if (row.selectedMaterial && row.selectedMaterial.unitId) {
        return row.selectedMaterial.unitId;
      }
      return ""; 
    });
    const spaceNameId = newRows.map(row => row.selectedRoom);
    const materials = newRows.map(row => row.selectedMaterial);
    const qtys = newRows.map(row => row.qty);
   
    setSelectedRoom(prevSelectedRooms => [
      ...prevSelectedRooms,
      ...spaceNameId
    ]);
    setSelectedScope(prevSelectedScopes => [
      ...prevSelectedScopes,
      ...DataScope
    ]);
    setSelectedSubCategory(prevSelectedSubCategories => [
      ...prevSelectedSubCategories,
      ...DataSubCategory
    ]);
    setSelectedMaterial(prevSelectedMaterials => [
      ...prevSelectedMaterials,
      ...materials
    ]);
    setSelectedUom(prevSelectedUoms => [
      ...prevSelectedUoms,
      ...DataUnit
    ]);
    setQuantity(prevQuantities => [
      ...prevQuantities,
      ...qtys,
    ]);
    
  };
  useEffect(() => {
    
    const imosTableRowData = Array.isArray(props.IomsData) ? props.IomsData.length : 0;
    let tableRowData = tableRows.length;
    let totalRowDataLength = imosTableRowData + tableRowData;
    const rowsArray = Array.from({ length: totalRowDataLength-1 }, (_, i) => {
      return i;
    });
     setTableRows(rowsArray)
  }, [props.IomsData]);

  const totalRowCount = tableRows?.length || 0
  const [visibleRowCount, setVisibleRowCount] = useState(ROW_RENDER_CHUNK)

  useEffect(() => {
    setVisibleRowCount(Math.min(ROW_RENDER_CHUNK, totalRowCount) || ROW_RENDER_CHUNK)
  }, [totalRowCount])

  useEffect(() => {
    if (visibleRowCount >= totalRowCount) return undefined
    const frame = requestAnimationFrame(() =>
      setVisibleRowCount(count => Math.min(count + ROW_RENDER_CHUNK, totalRowCount))
    )
    return () => cancelAnimationFrame(frame)
  }, [visibleRowCount, totalRowCount])

  const rowsBeingPainted = visibleRowCount < totalRowCount
  const visibleRows = rowsBeingPainted ? tableRows.slice(0, visibleRowCount) : tableRows

  useEffect(() => {
    if (readyNotified.current) return
    if (!mastersLoaded || !bomLoaded || rowsBeingPainted) return
    readyNotified.current = true
    props.ONREADY && props.ONREADY()
    // eslint-disable-next-line
  }, [mastersLoaded, bomLoaded, rowsBeingPainted])

  
  return (
    <div>
      <div>
        {userRoleAccess && props.TYPE === "CREATE" && tableRows.length > 1 &&
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 15 }} >
            <Button style={{ background: "#C0C0C0", color: "black", margin: 5 }} disabled >
            Uploaded By: {uploadDetails.submittedBy?.name} | with time:  {moment(uploadDetails.submittedAt).format('MMMM Do YYYY, h:mm:ss a')}
            </Button>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Button variant="contained" color="primary" style={{ background: "#34bf73", margin: 5 }} onClick={() => editBomStatus('Approved')}>
                  Approve
                </Button>
                <Button variant="contained" color="primary" style={{ background: "#f50057", margin: 5 }} onClick={() => editBomStatus('Rejected')}>
                  Reject
                </Button>
              </div>
          </div>
        }

        <TableContainer component={Paper}>
          <Table className={classes.table} size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Sl No</StyledTableCell>
                <StyledTableCell>Select Room</StyledTableCell>
                <StyledTableCell>Select Scope</StyledTableCell>
                <StyledTableCell>Select Sub Category</StyledTableCell>
                <StyledTableCell>Select Material</StyledTableCell>
                <StyledTableCell>UOM</StyledTableCell>
                <StyledTableCell>Qty</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visibleRows?.map((row, i) => (
                <StyledTableRow key={i + 1}
                  style={{ border: selectedMaterial[i]?.status === 'Inactive' ? '2px solid #000' : '' }} >
                  <StyledTableCell>{i + 1}</StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getSelectedRoom(i)}
                    disabled={fieldsDisabled}
                    onChange={(e, v) => handleRoomSelect(e, v, i)}
                    options={rooms}
                    getOptionLabel={optionLabel}
                    getOptionSelected={optionSelected}
                    style={{ width: 150 }}
                    renderInput={(params) => <TextField {...params} label="Select Room" fullWidth size="small" variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getSelectedScope(i)}
                    disabled={fieldsDisabled}
                    onChange={(e, v) => handleScopeSelect(e, v, i)}
                    options={scopes}
                    getOptionLabel={optionLabel}
                    getOptionSelected={optionSelected}
                    style={{ width: 150, fontSize: '12px' }}
                    renderInput={(params) => <TextField {...params} label="Select Scope" fullWidth size="small" variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getSelectedCategory(i)}
                    disabled={fieldsDisabled}
                    onChange={(e, v) => handleSubCategorySelect(e, v, i)}
                    getOptionLabel={optionLabel}
                    getOptionSelected={optionSelected}
                    options={subCategory}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    style={{ width: 200 }}
                    renderInput={(params) => <TextField {...params} label="Select sub category" fullWidth size="small" variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getSelectedMaterial(i)}
                    disabled={fieldsDisabled}
                    onChange={(e, v) => {
                      if (typeof v === 'string') {
                        setTimeout(() => {
                          let materials = [...selectedMaterial]
                          materials[i] = { name: v }
                          setSelectedMaterial(materials)
                        });
                      } else if (v && v.inputValue) {
                        v.inputValue = v.inputValue?.toLowerCase().replace(/\b\w/g, match => match.toUpperCase());
                        let materials = [...selectedMaterial]
                        materials[i] = { name: v.inputValue }
                        setSelectedMaterial(materials)
                      } else {
                        handleMaterialSelect(e, v, i)
                      }
                    }}
                    options={selectedSubCategoryMaterial}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      if (params.inputValue !== "") {
                        const words = params.inputValue.split(" ");
                        const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
                        const capitalizedPhrase = capitalizedWords.join(" ");
                        filtered.push({ inputValue: capitalizedPhrase, name: `Add "${capitalizedPhrase}"` });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionLabel={optionLabel}
                    getOptionSelected={optionSelected}
                    style={{ width: 250 }}
                    renderInput={(params) => <TextField {...params} label="Select Material" fullWidth size="small" variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell><Autocomplete
                    value={getSelectedUom(i)}
                    disabled={fieldsDisabled}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      if (params.inputValue !== '') {
                        filtered.push({
                          inputValue: params.inputValue,
                          name: `Add "${params.inputValue}"`,
                        });
                      }
                      return filtered;
                    }}
                    onChange={(e, v) => {
                      if (typeof v === 'string') {
                        setTimeout(() => {
                          handleUomSelect({ name: v })
                        });
                      } else if (v && v.inputValue) {
                        handleUomSelect(null, { name: v.inputValue }, i)
                      } else {
                        handleUomSelect(e, v, i)
                      }
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={units}
                    getOptionLabel={optionLabel}
                    getOptionSelected={optionSelected}
                    style={{ width: 150 }}
                    renderInput={(params) => <TextField {...params} label="Select UOM" fullWidth size="small" variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell><TextField className={classes.textField} value={quantity[i]} disabled={fieldsDisabled} onChange={(e) => handleQuantity(e, i)} type="number" size="small" variant="outlined" /></StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={showCommonBomItems}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xl'}
          onClose={resetCommonBomItemsData}
          aria-labelledby="alert-dialog-slide-title1"
          aria-describedby="alert-dialog-slide-description1"
        >
        <DialogTitle id="alert-dialog-slide-title1">{commonBomItems.length > 0 ? "Common BOM Items" : "There Are No Items To Be Added"}</DialogTitle>
        
        <DialogContent>
          <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Sl No</StyledTableCell>
                  <StyledTableCell>Select Room</StyledTableCell>
                  <StyledTableCell>Select Scope</StyledTableCell>
                  <StyledTableCell>Sub Category</StyledTableCell>
                  <StyledTableCell>Material</StyledTableCell>
                  <StyledTableCell>Select UOM</StyledTableCell>
                  <StyledTableCell>Qty</StyledTableCell>
                  <StyledTableCell>Remove</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {commonBomItems?.map((row, i) => (
                  // <StyledTableRow key={i + 1} style={{ border: selectedMaterial[i]?.status === 'Inactive' ? '2px solid #000' : '' }} >
                  <StyledTableRow key={i + 1} >
                    <StyledTableCell>{i + 1}</StyledTableCell>
                    
                    <StyledTableCell>
                      <Autocomplete
                      // value={getSelectedRoomInCommonBomItems(i)}
                      value={row.space}
                      disabled={false}
                      onChange={(e, v) => handleRoomSelectInCommonBomItems(e, v, i)}
                      options={rooms}
                      getOptionLabel={optionLabel}
                      getOptionSelected={optionSelected}
                      style={{ width: 150 }}
                      renderInput={(params) => <TextField {...params} label="Select Room" fullWidth size="small" variant="outlined" />}
                      />
                    </StyledTableCell>
                    
                    <StyledTableCell>
                      <Autocomplete
                      // value={getSelectedScopeInCommonBomItems(i)}
                      value={row.scope}
                      disabled={false}
                      onChange={(e, v) => handleScopeSelectInCommonBomItems(e, v, i)}
                      options={scopes}
                      getOptionLabel={optionLabel}
                      getOptionSelected={optionSelected}
                      style={{ width: 150, fontSize: '12px' }}
                      renderInput={(params) => <TextField {...params} label="Select Scope" fullWidth size="small" variant="outlined" />}
                      />
                    </StyledTableCell>
                    
                    <StyledTableCell>
                    <TextField
                      // className={classes.textField}
                      value={row.subCategory.name}
                      disabled={true}
                      // onChange={(e) => handleQuantityInCommonBomItems(e, i)}
                      type="test"
                      size="large"
                      variant="outlined"
                      />
                    </StyledTableCell>
                    
                    <StyledTableCell>
                      <TextField
                      // className={classes.textField}
                      value={row.material.name}
                      disabled={true}
                      // onChange={(e) => handleQuantityInCommonBomItems(e, i)}
                      type="test"
                      size="large"
                      variant="outlined"
                      />
                    </StyledTableCell>
                    
                    <StyledTableCell>
                      <Autocomplete
                      // value={getSelectedUomInCommonBomItems(i)}
                      value={row.unitType}
                      disabled={false}
                      
                      onChange={(e, v) => {
                        handleUomSelectInCommonBomItems(e, v, i)
                      }}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      options={units}
                      getOptionLabel={optionLabel}
                      getOptionSelected={optionSelected}
                      style={{ width: 150 }}
                      renderInput={(params) => <TextField {...params} label="Select UOM" fullWidth size="small" variant="outlined" />}
                      />
                    </StyledTableCell>
                    
                    <StyledTableCell>
                      <TextField
                      className={classes.textField}
                      // value={quantityInCommonBomItems[i]}
                      value={row.quantity}
                      disabled={false}
                      onChange={(e) => handleQuantityInCommonBomItems(e, i)}
                      type="number"
                      size="small"
                      variant="outlined"
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <DeleteIcon style={{ cursor: "pointer", verticalAlign: 'middle', marginLeft: 10, color: "red", fontSize: 20 }} onClick={() => handleRemoveCommonBomItemFromTable(i)} />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={resetCommonBomItemsData} color="primary">
            CANCEL
          </Button>
          <Button disabled={false} 
            onClick={addCommonBomItemsToBom} color="primary">
            {commonBomItems.length > 0 ? 'ADD TO BOM' : 'PROCEED'}
          </Button>
        </DialogActions>
      </Dialog>
      
        {/* {inActiveMaterials?.length > 0 && <> */}
        {(inActiveMaterials?.length > 0 && !DONT_SHOW_REMAP_TABLE.includes(userDetails.email)) && <>
          <div style={{ fontSize: 18, marginTop: 10, marginBottom: 10 }}><b>New Materials</b></div>
          <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Sl No</StyledTableCell>
                  <StyledTableCell>Material Name</StyledTableCell>
                  <StyledTableCell>Re Map</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inActiveMaterials?.map((material, i) => (
                  <StyledTableRow key={i + 1} >
                    <StyledTableCell>{i + 1}</StyledTableCell>
                    <StyledTableCell>{material?.materialId?.name}</StyledTableCell>
                    <StyledTableCell>
                      {material?.materialId?.status !== "Sent for Approval" && <Autocomplete
                        value={getRemappedMaterial(i)}
                        onChange={(e, v) => handleRemapOfMaterial(v, i)}
                        options={allMaterials}
                        getOptionLabel={optionLabel}
                        getOptionSelected={optionSelected}
                        // style={{ width: 250, fontSize: '12px' }}
                        renderInput={(params) => <TextField {...params} label="Remap Materials" fullWidth size="small" variant="outlined" />}
                      />}</StyledTableCell>
                    <StyledTableCell>
                      {material?.materialId?.status !== "Sent for Approval" ? <StyledTableRow>
                        <StyledTableCell>
                          <Button variant="contained" color="primary" style={{ background: "#34bf73", margin: 5 }} onClick={() => remapMaterial(material?.materialId?._id, i)}>
                            REMAP
                          </Button>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} onClick={() => sendForApproval(material?.materialId?._id)}>
                            Send For Approval
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow> :
                        <StyledTableRow> Pending For Approval</StyledTableRow>
                      }
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>}
        {props.TYPE !== "VIEW" && props.TYPE !== "VIEW-PENDING" &&
          <div style={{ display: "flex", flexDirection: "row-reverse", marginTop: 15 }} >
            <Button variant="contained" color="primary" style={{ background: "#355025", margin: 5 }} onClick={addRows}>
              Show
            </Button>
            <TextField label="Rows to Show" value={rowsToAdd && Math.max(0,rowsToAdd)} type="number"  min="0" onChange={(e) => setRowsToAdd(e.target.value  ? Number(e.target.value) : e.target.value)} variant="outlined" />
          </div>}
      </div>
      {
        props.TYPE !== "VIEW" && props.TYPE !== "VIEW-PENDING" && <div 
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
            marginTop: 15,
            gap: 10,
            flexWrap: "wrap",
          }} 
        >
          <div
            onClick={() => !props.LOCKINITIATIONBOM && setIsInitiationBom(!isInitiationBom)}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: props.LOCKINITIATIONBOM ? "not-allowed" : "pointer",
              userSelect: "none",
              padding: "6px 10px",
              borderRadius: 6,
              background: initiationBomChecked ? "#e8f5e9" : "#f5f5f5",
              border: `1px solid ${
                initiationBomChecked ? "#4caf50" : "#dcdcdc"
              }`,
              transition: "0.2s ease",
              marginRight: 10,
            }}
          >
            <input
              type="checkbox"
              checked={initiationBomChecked}
              disabled={!!props.LOCKINITIATIONBOM}
              onChange={(e) => setIsInitiationBom(e.target.checked)}
              onClick={(e) => e.stopPropagation()}
              style={{ marginRight: 8, cursor: props.LOCKINITIATIONBOM ? "not-allowed" : "pointer" }}
            />

            <span style={{ fontWeight: 500 }}>
              Is Initiation BOM
            </span>
          </div>
          <Button variant="contained" disbaled={Object.keys(inActiveMaterials).length} color="primary" style={{ background: "#F47E46", margin: 5 }} onClick={() => submit('Submitted')}>
            Submit
          </Button>
          <Button variant="contained" color="primary" style={{ background: "#FDB913", margin: 5 }} onClick={() => submit('Saved')}>
            Save Progress
          </Button>
          <Button variant="contained" color="primary" style={{ background: "#F47E46", margin: 5 }} onClick={resetBom}>
            Reset
          </Button>
        </div>
      }
      Note: Only after all materials have been approved, Bom can be submitted
    </div >
  )
}

export default connect(null, { setLoading, setSnackInfo, getAllScopes, getAllMaterials, getAllUnits })(BomTable)